import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('ui.components.Tag', {
    remove: 'Remove {title}',
});
